import { ClipboardEvent } from "react";

import { isNotNullOrEmpty } from "../../../Common/TypingUtils";

import { getSelectionFromEvent } from "./GetSelectionFromEvent";

interface CutExtraSpacesFromPaste {
    event: ClipboardEvent<unknown>;
    previousText: string | undefined;
    removeNewLines?: boolean;
}

export function cutExtraSpacesFromPaste({
    event,
    previousText = "",
    removeNewLines = false,
}: CutExtraSpacesFromPaste): string {
    let parsedPrevText = previousText;
    const isReplaced = isNotNullOrEmpty(previousText);
    if (isReplaced) {
        parsedPrevText = previousText.replace(/\r/g, "");
    }
    let pastedText = event.clipboardData.getData("Text");

    if (removeNewLines) {
        pastedText = pastedText.replace(/(\r\n|\r|\n)/g, " ");
    }

    const { start, end } = getSelectionFromEvent(event.target);
    const startValue = parsedPrevText.substring(0, start);
    const endValue = parsedPrevText.substring(end);

    const joinedText = startValue + pastedText + endValue;
    const result = joinedText.replace(/ +/g, " ").replace(/(( $)|(^ ))/g, "");

    return result;
}

export function cutExtraSpaces(currentText: string | undefined): string {
    if (currentText === null || currentText === undefined) {
        return "";
    }
    const result = currentText.replace(/ +/g, " ").replace(/(( $)|(^ ))/g, "");
    return result;
}
